import { Link as MuiLink } from '@mui/material';
import { PropsWithChildren } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { ButtonColor } from 'shared/Button';

interface OrangeLinkProps {
  text?: string;
  testId?: string;
  to?: string;
  className?: string;
  target?: '_blank' | '_self';
  onClick?: () => void;
}

export const OrangeLink = ({
  to = '',
  text,
  testId = 'custom-link',
  className,
  children,
  target = '_self',
  onClick,
}: PropsWithChildren<OrangeLinkProps>) => {
  return (
    <MuiLink
      component={RouterLink}
      to={to}
      target={target}
      data-testid={testId}
      className={className}
      onClick={onClick}
      sx={{
        color: ButtonColor.DEFAULT,
        textDecoration: 'none',
        '&:hover': {
          textDecoration: 'underline',
        },
      }}
    >
      {text || children}
    </MuiLink>
  );
};
